"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _theme = require("../utils/theme");
var _styledComponents = require("styled-components");
var _Icon = require("../Icon");
var _excluded = ["text", "theme", "placement"];
var Tooltip = function Tooltip(_ref) {
  var text = _ref.text,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    params = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: text,
    placement: placement,
    arrow: true,
    style: {
      width: 'fit-content'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: 'fit-content'
    }
  }, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, (0, _extends2["default"])({
    dense: true,
    icon: "info-mark-circle"
  }, params)))));
};
var _default = exports["default"] = Tooltip;